/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InformationExtractionLanguageEnum } from './InformationExtractionLanguageEnum';
import {
  InformationExtractionLanguageEnumFromJSON,
  InformationExtractionLanguageEnumFromJSONTyped,
  InformationExtractionLanguageEnumToJSON,
} from './InformationExtractionLanguageEnum';
import type { InformationExtractionDataset } from './InformationExtractionDataset';
import {
  InformationExtractionDatasetFromJSON,
  InformationExtractionDatasetFromJSONTyped,
  InformationExtractionDatasetToJSON,
} from './InformationExtractionDataset';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface GenerationInputsPolymorphicInformationExtractionGenerationInputs
 */
export interface GenerationInputsPolymorphicInformationExtractionGenerationInputs {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof GenerationInputsPolymorphicInformationExtractionGenerationInputs
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicInformationExtractionGenerationInputs
   */
  readonly id: number;
  /**
   *
   * @type {InformationExtractionLanguageEnum}
   * @memberof GenerationInputsPolymorphicInformationExtractionGenerationInputs
   */
  language?: InformationExtractionLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicInformationExtractionGenerationInputs
   */
  minNumSamples?: number;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicInformationExtractionGenerationInputs
   */
  maxNumAttempts?: number;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicInformationExtractionGenerationInputs
   */
  maxWorkers?: number;
  /**
   *
   * @type {boolean}
   * @memberof GenerationInputsPolymorphicInformationExtractionGenerationInputs
   */
  verifySamples?: boolean;
  /**
   *
   * @type {InformationExtractionDataset}
   * @memberof GenerationInputsPolymorphicInformationExtractionGenerationInputs
   */
  seedDocuments: InformationExtractionDataset;
}

/**
 * Check if a given object implements the GenerationInputsPolymorphicInformationExtractionGenerationInputs interface.
 */
export function instanceOfGenerationInputsPolymorphicInformationExtractionGenerationInputs(
  value: object,
): value is GenerationInputsPolymorphicInformationExtractionGenerationInputs {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('seedDocuments' in value) || value['seedDocuments'] === undefined) return false;
  return true;
}

export function GenerationInputsPolymorphicInformationExtractionGenerationInputsFromJSON(
  json: any,
): GenerationInputsPolymorphicInformationExtractionGenerationInputs {
  return GenerationInputsPolymorphicInformationExtractionGenerationInputsFromJSONTyped(json, false);
}

export function GenerationInputsPolymorphicInformationExtractionGenerationInputsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenerationInputsPolymorphicInformationExtractionGenerationInputs {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    language: json['language'] == null ? undefined : InformationExtractionLanguageEnumFromJSON(json['language']),
    minNumSamples: json['min_num_samples'] == null ? undefined : json['min_num_samples'],
    maxNumAttempts: json['max_num_attempts'] == null ? undefined : json['max_num_attempts'],
    maxWorkers: json['max_workers'] == null ? undefined : json['max_workers'],
    verifySamples: json['verify_samples'] == null ? undefined : json['verify_samples'],
    seedDocuments: InformationExtractionDatasetFromJSON(json['seed_documents']),
  };
}

export function GenerationInputsPolymorphicInformationExtractionGenerationInputsToJSON(
  value?: Omit<GenerationInputsPolymorphicInformationExtractionGenerationInputs, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    language: InformationExtractionLanguageEnumToJSON(value['language']),
    min_num_samples: value['minNumSamples'],
    max_num_attempts: value['maxNumAttempts'],
    max_workers: value['maxWorkers'],
    verify_samples: value['verifySamples'],
    seed_documents: InformationExtractionDatasetToJSON(value['seedDocuments']),
  };
}
